module.exports = __webpack_public_path__ + "img/black_bgm.593ff584.png";